import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { DatesProvider } from "@mantine/dates";
import "dayjs/locale/pt-br";
import { App } from "./App";
import { ErrorBoundary } from "./componentes/ErrorBoundary";
import { tema } from "./tema";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";

createRoot(document.getElementById("raiz")!).render(
  <MantineProvider theme={tema}>
    <DatesProvider settings={{ locale: "pt-br", firstDayOfWeek: 0 }}>
      <Notifications position="bottom-right" limit={4} />
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </DatesProvider>
  </MantineProvider>,
);
